import React from 'react';
import { Container } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import {
  LbTabs,
  LbTabPanel,
  LbToggleTabsList,
  TabsConfig,
} from '../../../shared/components/tabs';
import { CoachNutritionRegistrationTab } from './tabs/CoachNutritionRegistrationTab';
import { CoachScanIqRegistrationTab } from './tabs/CoachScanIqRegistrationTab';
import { CoachSystemSettingsTab } from './tabs/CoachSystemSettingsTab';
import classes from './NgzSettings.module.scss';

const SETTINGS_TAB = {
  NUTRITION_REGISTRATION: 'NUTRITION_REGISTRATION',
  SCAN_IQ_REGISTRATION: 'SCAN_IQ_REGISTRATION',
  SYSTEM_SETTINGS: 'SYSTEM_SETTINGS',
} as const;

const NgzCoachSettingsPage = observer(() => {
  const { solutionTypeFlags } = solutionsStore;

  const tabsConfig: TabsConfig[] = [
    {
      label: 'Nutrition Customer Registration',
      value: SETTINGS_TAB.NUTRITION_REGISTRATION,
      hide: !solutionTypeFlags.NUTRITION,
      panel: <CoachNutritionRegistrationTab />,
    },
    {
      label: 'ScanIQ Customer Registration',
      value: SETTINGS_TAB.SCAN_IQ_REGISTRATION,
      hide: !solutionTypeFlags.SCAN_IQ,
      panel: <CoachScanIqRegistrationTab />,
    },
    {
      label: 'System Settings',
      value: SETTINGS_TAB.SYSTEM_SETTINGS,
      panel: <CoachSystemSettingsTab />,
    },
  ];

  const defaultTab =
    tabsConfig.find((t) => !t.hide)?.value ?? SETTINGS_TAB.SYSTEM_SETTINGS;

  return (
    <Container>
      <h1 className={classes.title}>Settings</h1>
      <LbTabs defaultValue={defaultTab}>
        <LbToggleTabsList
          size="small"
          tabsConfig={tabsConfig}
          className={classes.tabsList}
        />
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </Container>
  );
});

angularizeWithProviders(NgzCoachSettingsPage, 'ngzCoachSettingsPage', {});

export { NgzCoachSettingsPage };
